import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'

export const getRisorse = gql`
  ${seoFragment}
  query GetRisorse($site: [String]) {
    risorsePageEntries(site: $site) {
      ... on risorsePage_Entry {
        id
        seo {
          ...SeoFragment
        }
      }
    }
    comeFarePerEntries(site: $site) {
      ... on comeFarePer_Entry {
        id
        title
        slug
        custom: immagine @transform(format: "webp", width: 600, height: 400) {
          id
          url
          width
          srcset(sizes: ["750w", "1300w", "1920w"])
          height
          title
        }
      }
    }
    modalitaDusoEntries(site: $site) {
      ... on modalitaDuso_Entry {
        id
        title
        slug
        tipologiaModalitaDuso
      }
    }
  }
`
